import styled from 'styled-components';

import CapsuleIcon from 'src/app/components/Elements/CapsuleIcon';

export const PageDesignWrapper = styled.div`
  position: relative;
  top: ${props => props.theme.space.s6};
  height: 100%;
  ${({ theme }) => theme.mediaQueries.small} {
    margin-top: -${props => props.theme.space.s6};
  }
`;

export const RoundPillDesign = styled(CapsuleIcon)`
  position: absolute;
  fill: ${props => props.theme.colors.capsuleGreen00} !important;
  transform: rotate(-55deg);
  width: 10rem;
  height: 9rem;
  bottom: 18rem;
  left: -4rem;
`;

export const PillDiamondDesign = styled(CapsuleIcon)`
  position: absolute;
  fill: ${props => props.theme.colors.capsuleGreen00} !important;
  transform: rotate(-140deg);
  width: 15rem;
  height: 10rem;
  top: 3rem;
  right: -6rem;
`;
